<template>
  <div
    class="settings-layout__wrapper"
    :class="{ ['submenu-opened']: submenuOpened }"
  >
    <sidebar-layout no-content></sidebar-layout>
    <the-settings-menu
      :links="getLinks"
      :avatar="userAvatar"
    ></the-settings-menu>
    <div
      class="settings-layout__content"
      :style="borderRadiusStyles"
      ref="settingsContent"
    >
      <div class="settings-layout__inner">
        <div
          class="settings-layout__sub-menu-toggle"
          @click="setSettingsSubmenuStatus(!submenuOpened)"
        >
          <img :src="toggleIcon" alt="hamb-icon" />
        </div>

        <!-- Need to add this div to fix annoying FF bug with padding-bottom -->
        <!-- Discussion here: https://github.com/w3c/csswg-drafts/issues/129 -->
        <div :style="{ paddingBottom: '20px' }">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters, mapActions } from "vuex";

import SidebarLayout from "@/layouts/SidebarLayout";
import TheSettingsMenu from "@/components/TheSettingsMenu";
import withCardContent from "@/mixins/withCardContent";
import toggleIcon from "@/assets/images/toggleicon.svg";

export default Vue.component("SettingsLayout", {
  data() {
    return {
      toggleIcon
    };
  },

  mixins: [withCardContent("settingsContent")],

  methods: {
    ...mapActions("service", ["setSettingsSubmenuStatus"])
  },

  computed: {
    getLinks() {
      const { path } = this.$route;

      return [
        {
          key: "organization",
          url: "/account/organization",
          active: path === "/account/organization",
          label: "Organization",
          submenu: [
            {
              key: "organization-general",
              url: "/account/organization/general",
              active: path === "/account/organization/general",
              label: "General Settings"
            },
            {
              key: "organization-address",
              url: "/account/organization/address",
              active: path === "/account/organization/address",
              label: "Return Address"
            },
            {
              key: "organization-billing",
              url: "/account/organization/billing",
              label: "Billing",
              active:
                path === "/account/organization/billing" ||
                path === "/account/organization/billing-settings"
            }
          ]
        },
        {
          key: "preferences",
          url: "/account/preferences",
          label: "Preferences",
          active: path === "/account/preferences"
        },
        {
          key: "api/integrations",
          url: "/account/integrations",
          label: "API/Integrations",
          active: path === "/account/integrations"
        },
        {
          key: "api/notifications",
          url: "/account/notifications",
          label: "Notifications",
          active: path === "/account/notifications"
        },
        {
          key: "address-validation",
          url: "/account/address-validation",
          label: "Address Validation",
          active: path === "/account/address-validation"
        },
        {
          key: "status",
          url: "https://status.inkit.com",
          label: "Status",
          external: true
        },
        {
          key: "logout",
          url: "/logout",
          label: "Logout"
        }
      ];
    },

    getBillingInfo() {
      return this.$store.state.billing.creditCards;
    },

    noBilling() {
      return this.getBillingInfo && !this.getBillingInfo.length;
    },

    userAvatar() {
      if (this.getUser === null) {
        return null;
      }

      return this.gravatar;
    },

    ...mapGetters("account", ["getUser"]),
    ...mapGetters("service", ["submenuOpened"]),
    ...mapGetters("user", ["gravatar"])
  },
  components: {
    SidebarLayout,
    TheSettingsMenu
  }
});
</script>

<style lang="scss" scoped>
$ns: "settings-layout";

.#{$ns} {
  &__wrapper {
    display: flex;
    height: 100%;
    background: #ebeef0;

    &.submenu-opened {
      background: #f6f6f6;
    }
  }

  &__inner {
    position: relative;
  }

  &__sub-menu-toggle {
    cursor: pointer;
    position: absolute;
    color: $button-dark-color;
    padding-top: 6px;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  &__content {
    flex: 1;
    max-height: 100vh;
    padding: $general-padding $general-padding 0 40px;
    overflow-y: scroll;
    background-color: $white;
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05), 0 4px 24px 2px rgba(0, 0, 0, 0.1);
  }
}
@media screen and (max-width: 991px) {
  .#{$ns}__content {
    padding: 80px 20px;
  }

  .#{$ns}__sub-menu-toggle {
    display: none;
  }
}
</style>

<style lang="scss">
.settings-layout__content .sidebar-layout-heading {
  /*margin-bottom: 7px;*/
}
</style>
